<script lang="ts">
    import {getLocalization} from 'src/core';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {get} from 'svelte/store';
    import {exists} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {toggleStrikethroughCommand} from '@milkdown/preset-gfm';
    import ToolbarButton from './ToolbarButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    function toggleStrikethrough() {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(toggleStrikethroughCommand.key)
        );
    }
</script>

<ToolbarButton icon="strikethrough"
               tooltipLabel={localize(/* @kp-localization richTextArea.tools.strikethrough */ 'richTextArea.tools.strikethrough')}
               on:click={toggleStrikethrough}/>